import {
  Box,
  ModalProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
} from "dash-ui";

import ApiPluginUsersPageHeader from "./components/ApiPluginUsersPageHeader/ApiPluginUsersPageHeader";
import ApiPluginUsersPageTable from "./components/ApiPluginUsersPageTable/ApiPluginUsersPageTable";

const ApiPluginUsersPage = () => (
  <PaginationProvider>
    <SortProvider>
      <SearchProvider>
        <ModalProvider>
          <Box w="100%">
            <ApiPluginUsersPageHeader />
            <ApiPluginUsersPageTable />
          </Box>
        </ModalProvider>
      </SearchProvider>
    </SortProvider>
  </PaginationProvider>
);

export default ApiPluginUsersPage;
